import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { AssetHeaderComponent, AssetHeaderConfig } from '../../shared/components/asset-header/asset-header.component';
import { FooterComponent } from '../../shared/components/footer/footer.component';
import { LoginModalComponent } from '../../shared/components/login-modal/login-modal.component';
import { MySubmissionsComponent } from '../leadership/my-submissions/my-submissions.component';

@Component({
  selector: 'app-my-submissions-page',
  standalone: true,
  imports: [
    CommonModule,
    AssetHeaderComponent,
    FooterComponent,
    LoginModalComponent,
    MySubmissionsComponent,
  ],
  templateUrl: './my-submissions-page.component.html',
  styleUrl: './my-submissions-page.component.scss',
})
export class MySubmissionsPageComponent implements OnInit {
  private keycloak = inject(KeycloakService);
  private router = inject(Router);

  isLoggedIn = false;
  showLoginModal = false;
  loginRedirectUri = '';

  headerConfig: AssetHeaderConfig = {
    breadcrumbs: [
      { label: 'Home', route: '/' },
      { label: 'My Submissions' },
    ],
    title: 'My Submissions',
    description: 'View and manage your model evaluation submissions.',
  };

  async ngOnInit(): Promise<void> {
    this.loginRedirectUri = `${window.location.origin}/my-submissions`;
    try {
      this.isLoggedIn = await this.keycloak.isLoggedIn();
      if (!this.isLoggedIn) {
        this.showLoginModal = true;
      }
    } catch {
      this.showLoginModal = true;
    }
  }

  onLoginModalClose(visible: boolean): void {
    this.showLoginModal = visible;
    if (!visible && !this.isLoggedIn) {
      this.router.navigate(['/']);
    }
  }
}
